<script>
  import { get } from 'vuex-pathify'

  export default {
    computed: {
      ...get(['route']),
      ...get('products', ['loaded']),
      ...get('prismic', ['marketCollectionPillsData']),
      activeSlug() {
        return this.route.params ? this.route.params.collection : null
      },
      prismicLoading() {
        return this.marketCollectionPillsData === null
      },
      displayCollections() {
        return (this.marketCollectionPillsData || []).map((item) => ({
          slug: item.collection_slug,
          title: item.collection_title,
        }))
      },
    },
  }
</script>

<template>
  <!-- Skeleton pills while products or Prismic data are loading -->
  <div v-if="!loaded || prismicLoading" class="overflow-x-auto -mx-6 sm:-mx-9 lg:-mx-0">
    <div class="flex gap-2 px-6 sm:px-9 lg:px-0 pb-3 pt-4">
      <div
        v-for="(w, i) in [36, 72, 88, 64, 96, 60, 80, 68]"
        :key="i"
        class="skeleton flex-shrink-0 h-9 rounded-full"
        :style="`width: ${w}px`"
      />
    </div>
  </div>

  <div v-else class="overflow-x-auto -mx-6 sm:-mx-9 lg:-mx-0">
    <div
      class="flex gap-2 px-6 sm:px-9 lg:px-0 pb-3 pt-4"
      style="-webkit-overflow-scrolling: touch"
    >
      <!-- "All" pill -->
      <RouterLink
        :to="{ name: 'MarketProductList' }"
        :class="`flex-shrink-0 px-4 py-2 rounded-full text-sm transition ${
          !activeSlug
            ? 'bg-primary text-white font-semibold pointer-events-none'
            : 'bg-dawn-lt3 text-black border border-gray-active'
        }`"
      >
        All
      </RouterLink>

      <!-- Collection pills -->
      <RouterLink
        v-for="collection in displayCollections"
        :key="collection.slug"
        :to="{ name: 'MarketCollection', params: { collection: collection.slug } }"
        :class="`flex-shrink-0 px-4 py-2 rounded-full text-sm transition ${
          activeSlug === collection.slug
            ? 'bg-primary text-white font-semibold pointer-events-none'
            : 'bg-dawn-lt3 text-black border border-gray-active'
        }`"
      >
        {{ collection.title }}
      </RouterLink>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  @keyframes skeleton-shimmer {
    0% { background-position: -400px 0; }
    100% { background-position: 400px 0; }
  }

  .skeleton {
    display: block;
    background: linear-gradient(90deg, #ede5d8 25%, #f5ede0 50%, #ede5d8 75%);
    background-size: 800px 100%;
    animation: skeleton-shimmer 1.5s infinite linear;
  }
</style>
